import Button from '@ingka/button';
import crossIcon from '@ingka/ssr-icon/paths/cross';
import { translate } from '@repo/phrase';

import { useAssetPendingChangesGuard } from '@/hooks/asset-pending-changes-navigation.hooks';
import { navigateToCartHome } from '@/hooks/router.hooks';

export const AssetCloseButton = () => {
    const guardPendingChanges = useAssetPendingChangesGuard();

    return (
        <Button
            iconOnly
            size="small"
            type="tertiary"
            ssrIcon={crossIcon}
            onClick={() => {
                guardPendingChanges(navigateToCartHome);
            }}
            data-testid="asset-close-button"
            aria-label={translate('close')}
        />
    );
};
